import { Button, Checkbox, Col, Icon, Modal, Row, Select, Tabs, Tooltip, Dropdown, Menu, Input, Popover } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { onLoadPrinter } from '../../../../actions/headerAction';
import { addFilterShipment, addPackageInfo, deleteShipment, clearShipmentFailFeed, getLabelInfo, getPackageInfoById, getPackageInfoByShipmentId, getShipmentsByPage, nextOrBack, onChangeOffset, onCheckAll, onSort, onSubmit, onTab, toTransmited, update, toggleDataExportVisibility } from '../../../../actions/shipmentAction.js';
import { changeEditOrder } from './../../../../actions/editOrder';
import lang from './../../../../languages/en';
import copyDis from './../../../../resources/assets/images/copyDisable.png';
import copyEna from './../../../../resources/assets/images/copyEnable.png';
import deleteDis from './../../../../resources/assets/images/deleteDisable.png';
import deleteEna from './../../../../resources/assets/images/deleteEnable.png';
import filterDisble from './../../../../resources/assets/images/filter.png';
import filterEnable from './../../../../resources/assets/images/filterEnable.png';
import clearDisable from './../../../../resources/assets/images/clearDisable.png';
import clearEnable from './../../../../resources/assets/images/clear.png';
import measureDis from './../../../../resources/assets/images/measureDisable.png';
import measureEna from './../../../../resources/assets/images/measureEnable.png';
import printDis from './../../../../resources/assets/images/printDisable.png';
import printEna from './../../../../resources/assets/images/printeEnable.png';
import toTransmitDis from './../../../../resources/assets/images/totransmitDisable.png';
import toTransmitEna from './../../../../resources/assets/images/totransmitEnable.png';
import exportDataImg from './../../../../resources/assets/images/export-data.png';
import { convertDateToUTC } from './../../../../services/dst';
import handleException from './../../../../services/handleException';
import history from './../../../../services/history';
import { alertError, alertWarning, showConfirm } from './../../../../services/dialog';
import { shipmentStatus, StatusFilterShipment, permissions, settingPrintOptions, FulfillOption as FulfillOptionConst, feedTransmitStatus } from './../../../../constants';
import { getPrinter } from './../../../../utils/settingPrinter';
import AddFilterShipment from './../../components/add-filter';
import './styles.css';
import title from './title';
import { detectAdBlocker, checkIsChildArr, doPaging, getFirstValueObj } from './../../../../services/helper'
import handlePermission from './../../../app/handlePermission'
import Storage from '../../../../services/Storage';
import { isEqual, find } from "lodash";
import { Fragment } from 'react';

const TabPane = Tabs.TabPane
const confirm = Modal.confirm;
const Option = Select.Option
const Status = {
    [StatusFilterShipment.AWAITING_PACKAGE_INFO]: 'Awaiting Package Information',
    [StatusFilterShipment.READY_TO_PRINT]: 'Ready To Print',
    [StatusFilterShipment.READY_TO_TRANSMIT]: 'Ready To Transmit',
    [StatusFilterShipment.SHIPPED]: 'Shipped',
    [StatusFilterShipment.IN_TRANSIT]: 'In Transit',
    [StatusFilterShipment.DELIVERED]: 'Delivered',
    [StatusFilterShipment.FULFILLMENT_IN_PROCESS]: "Fulfillment In Process",
    [StatusFilterShipment.SHIPPING_IN_PROCESS]: "Shipping In Process",
    [StatusFilterShipment.FULFILLMENT_COMPLETED]: "Fulfillment Completed",
    [StatusFilterShipment.PENDING_SHIPPING_IN_PROCESS]: "Pending Shipping In Process",
    [StatusFilterShipment.TRANSMIT_FAIL]: "Transmission Error",
}
const TypeStatus = {
    1: 'Imported',
    2: 'Manual',
}
const StatusCanPrint = [
    shipmentStatus.READY_TO_PRINT,
    shipmentStatus.READY_TO_TRANSMIT,
    shipmentStatus.PENDING_TRANSMIT,
    shipmentStatus.TRANSMITED,
    shipmentStatus.TRANSMITED_KTE,
    shipmentStatus.IMPORTED_KTE,
    shipmentStatus.SHIPPED,
]
const StatusCanCreateAsNewOrder = [
    shipmentStatus.AWAITING_PACKAGE_INFO,
    shipmentStatus.READY_TO_PRINT,
    shipmentStatus.READY_TO_TRANSMIT,
    shipmentStatus.PENDING_TRANSMIT,
    shipmentStatus.FULFILLMENT_COMPLETED,
    shipmentStatus.SHIPPING_IN_PROCESS,
    shipmentStatus.FULFILLMENT_IN_PROCESS,
]
const StatusCanNotDelete = [
    shipmentStatus.TRANSMITED,
    shipmentStatus.TRANSMITED_KTE,
    shipmentStatus.IMPORTED_KTE,
    shipmentStatus.SHIPPED,
    shipmentStatus.ARRIVED_AT_DESTINATION,
    shipmentStatus.OUT_FOR_DELIVERY,
    shipmentStatus.DELIVERY_DELIVERED
]

const ChannelIdCanClearTransmissionError = [
    2
]

const FeedStatusCanClear = [
    feedTransmitStatus.FAIL,
]

const MaxPrintRecord = 500
const ALLOWED_EXPORT_SHIPMENT_STATUS = [
    shipmentStatus.TRANSMITED,
    shipmentStatus.TRANSMITED_KTE,
    shipmentStatus.IMPORTED_KTE,
    shipmentStatus.SHIPPED,
    shipmentStatus.ARRIVED_AT_DESTINATION,
    shipmentStatus.OUT_FOR_DELIVERY,
    shipmentStatus.DELIVERY_DELIVERED,
    shipmentStatus.SHIPPING_IN_PROCESS,
];

class BoxUtility extends Component {
    constructor(props) {
        super(props)
        this.state = {
            countReadyToPrint: 0,
            visibleEditOrder: false,
            displayModalSettingPrinter: false,
            package_id: '',
            title: {
                class: '',
                content: 'Shipments'
            }
        }

    }

    static getDerivedStateFromProps(props, state) {
        let title
        if (props.typeListShipment === FulfillOptionConst.YAMATO.TYPE_LINK) {
            title = {
                class: 'title-shipments-fulfillment',
                content: 'Shipments <span>Fulfillment by Yamato</span>'
            }
        } else if (props.typeListShipment === FulfillOptionConst.IN_HOUSE.TYPE_LINK) {
            title = {
                class: 'title-shipments-fulfillment',
                content: 'Shipments <span>In-House</span>'
            }
        } else {
            title = {
                class: '',
                content: 'Shipments'
            }
        }
        return {
            title
        }
    }
    componentDidMount() {
        let stick = document.getElementsByClassName('ant-tabs-ink-bar')
        if (stick) {
            stick[0].parentNode.removeChild(stick[0])
        }
        if (!handlePermission(permissions.PrinterGetPrinterSetting)) return
        getPrinter().then(printer => {
            this.props.onLoadPrinter(printer.data.data)
        }).catch(error => handleException(error))
    }

    Pagination = (current, total) => {
        const paging = { range: 5, pages: total }
        let arrayPaginate = doPaging(current, paging)
        if (total > 0) {
            let orderNew = []
            for (let i = 0; i < arrayPaginate.length; i++) {
                orderNew.push(
                    <a
                        key={i}
                        className={current == arrayPaginate[i] ? 'active' : ''}
                        onClick={() => { window.scrollTo(0, 0); return this.props.getShipmentsByPage({ current_page: arrayPaginate[i], params: this.props.getShipmentParams }) }
                        }
                    >
                        {arrayPaginate[i]}
                    </a>
                )
            }
            return orderNew
        } else return null
    }

    toCheckDelete = () => {
        let checkResult = true
        for (let i in this.props.listIdCheckedShipmentsWithStatus) {
            if (this.props.listIdCheckedShipmentsWithStatus[i] === shipmentStatus.TRANSMITED) {
                checkResult = false
            }
        }
        if (!checkResult) {
            alertError(lang.order_transmitted_cant_delete)
        } else {
            this.showConfirmDelete()
        }
    }

    toCheckClearTransmissionError = () => {
        let checkResult = this.CheckAllowClearShipmentTransmissionError();

        if (!checkResult) {
            alertError(lang.transmission_error_cant_clear)
        } else {
            this.showConfirmClearTransmissionError()
        }
    }

    showConfirmAddTrackingNo = (PackageIds, a, printOption) => {
        const printOpt = printOption || this.props.printer.PrintingOptionIN

        // Check if not in tab Ready To Print set IsRePrinting is true
        let { status_list } = this.props.input_filter;
        let IsRePrinting = !isEqual(status_list, [shipmentStatus.READY_TO_PRINT]);

        let title = ''
        let content = ''
        let body = ''
        const number = a

        if (!printOpt || !this.props.printer.PaperSize) {
            this.setState({
                displayModalSettingPrinter: true
            })
            return false
        }
        switch (printOpt) {
            case settingPrintOptions.ShippingLabelOnly:
                title = `${number} ${lang.print_label_only_modal_title}`
                content = lang.print_label_only_modal_content
                body = lang.tracking_no_not_changed
                break
            case settingPrintOptions.PackingListOnly:
                title = lang.print_packing_list_only_modal_title.replace('$number', number)
                content = lang.for_best_results
                break
            case settingPrintOptions.ShippingLabelAndPacking:
                title = `${number} ${lang.print_both_modal_title}`
                content = lang.print_both_modal_content
                body = lang.tracking_no_not_changed
                break
            default:
                break
        }

        let flagShowPopupBestResult
        let arrLabelPrintFlg = [];
        let lineWarningPrintFlg = "";
        let LabelPrintFlgs = Storage.get("LabelPrintFlgs");
        let { listIdCheckedShipmentsWithChannelId } = this.props;


        for (let i in listIdCheckedShipmentsWithChannelId) {
            let itemChannelFlag = find(LabelPrintFlgs, function (item) { return item.ChanelId === listIdCheckedShipmentsWithChannelId[i] });
            arrLabelPrintFlg.push(itemChannelFlag.LabelPrintFlg)

        }

        if (arrLabelPrintFlg.includes(false)) {
            lineWarningPrintFlg = lang.shipping_labels_disabled
        }

        if (arrLabelPrintFlg.includes(true)) {
            if (printOpt === settingPrintOptions.PackingListOnly) {
                flagShowPopupBestResult = false
            } else {
                flagShowPopupBestResult = true
            }
        } else {
            flagShowPopupBestResult = false;
        }

        let _this = this
        confirm({
            title: (
                <div>
                    <h4>{title}</h4>
                    <h4>{content}</h4>
                </div>
            ),
            content: (
                <div>
                    {body}
                    {lineWarningPrintFlg ? <div style={{ marginTop: "15px" }}> {lineWarningPrintFlg} </div> : ""}
                </div>
            ),
            autoFocusButton: null,
            onOk() {
                flagShowPopupBestResult ? alertWarning(lang.for_best_results,
                    '',
                    () => _this.props.getLabelInfo({ PackageIds: PackageIds, PrintingOptionIN: printOption, IsRePrinting: IsRePrinting }),
                    null,
                    'Print'
                )
                    : _this.props.getLabelInfo({ PackageIds: PackageIds, PrintingOptionIN: printOption, IsRePrinting: IsRePrinting })
            },
            onCancel() { },
        });
    }

    confirmPrint = (a, printOption) => {
        const printOpt = printOption || this.props.printer.PrintingOptionIN

        // Check if not in tab Ready To Print set IsRePrinting is true
        let { status_list } = this.props.input_filter;
        let IsRePrinting = !isEqual(status_list, [shipmentStatus.READY_TO_PRINT]);


        if (!printOpt || !this.props.printer.PaperSize) {
            this.setState({
                displayModalSettingPrinter: true
            })
            return false
        }

        let message = ''
        switch (printOpt) {
            case settingPrintOptions.ShippingLabelOnly:
                message = 'Are you sure you want to reprint these ' + a + ' label(s)?'
                break
            case settingPrintOptions.PackingListOnly:
                message = 'Are you sure you want to reprint these ' + a + ' packing list(s)?'
                break
            case settingPrintOptions.ShippingLabelAndPacking:
                message = 'Are you sure you want to reprint these ' + a + ' label(s) and packing list(s)?'
                break
            default:
                break
        }

        showConfirm(message,
            () => this.props.getLabelInfo({ PackageIds: this.props.listIdCheckedShipments, PrintingOptionIN: printOption, IsRePrinting: IsRePrinting }),
            null,
            lang.for_best_results
        )
    }

    showConfirmTransmit = (listIdCheckedShipments, listIdCheckedShipmentsWithStatus) => {
        let _this = this
        let status = shipmentStatus.TRANSMITED;
        let content = lang.confirm_transmit_data_shipment_content;
        let title = lang.confirm_transmit_data_shipment;
        let width = 420;
        // case transmit shipment fulfillment
        if (_this.props.fulfillment_option === FulfillOptionConst.YAMATO.CODE) {
            for (let key in listIdCheckedShipmentsWithStatus) {
                // if listIdCheckedShipmentsWithStatus has status FULFILLMENT_IN_PROCESS change content message
                if (listIdCheckedShipmentsWithStatus[key] === shipmentStatus.FULFILLMENT_IN_PROCESS) {
                    status = shipmentStatus.SHIPPING_IN_PROCESS;
                    width = 550
                    title = lang.confirm_transmit_data_shipment_fulfillment
                    content = lang.confirm_transmit_data_shipment_fulfillment_inprocess_content
                    break;
                } else if (listIdCheckedShipmentsWithStatus[key] === shipmentStatus.FULFILLMENT_COMPLETED) {
                    status = shipmentStatus.IMPORTED_KTE;
                    width = 550
                    title = lang.confirm_transmit_data_shipment_fulfillment
                    content = lang.confirm_transmit_data_shipment_fulfillment_completed_content
                    break;
                }
            }
        }



        confirm({
            title: title,
            autoFocusButton: null,
            content: content,
            width: width,
            onOk() {
                _this.props.toTransmited({ PackageIds: listIdCheckedShipments, Status: status })
            },
            onCancel() { },
        });
    }

    showConfirmDelete = () => {

        let _this = this
        confirm({
            title: lang.confirm_delete_shipment,
            autoFocusButton: null,
            cancelText: 'No',
            okText: 'Yes',
            onOk() {
                _this.props.deleteShipment({
                    PackageIDs: _this.props.listIdCheckedShipments,
                    IsBothOrder: false
                })
            },
            onCancel() { },
        });
    }

    showConfirmClearTransmissionError = () => {

        let _this = this;

        confirm({
            title: lang.confirm_clear_shipments_feed,
            autoFocusButton: null,
            cancelText: 'No',
            okText: 'Yes',
            onOk() {
                _this.props.clearShipmentFeed({
                    PackageIDs: _this.props.listIdCheckedShipments,
                })
            },
            onCancel() { },
        });
    }

    toTransmitedCheck = () => {
        let checkResult = true
        if (this.props.fulfillment_option === FulfillOptionConst.YAMATO.CODE) {
            for (let i in this.props.listIdCheckedShipmentsWithStatus) {
                if (this.props.listIdCheckedShipmentsWithStatus[i]
                    !== shipmentStatus.FULFILLMENT_IN_PROCESS
                    && this.props.listIdCheckedShipmentsWithStatus[i]
                    !== shipmentStatus.FULFILLMENT_COMPLETED
                    && this.props.listIdCheckedShipmentsWithStatus[i]
                    !== shipmentStatus.PENDING_TRANSMIT
                    && this.props.listIdCheckedShipmentsWithStatus[i]
                    !== shipmentStatus.PENDING_SHIPPING_IN_PROCESS
                ) {
                    checkResult = false
                }
            }
            if (!checkResult) {
                alertError(lang.only_fulfillment_can_transmetted)
            } else {
                this.showConfirmTransmit(this.props.listIdCheckedShipments, this.props.listIdCheckedShipmentsWithStatus)
            }
        } else {
            for (let i in this.props.listIdCheckedShipmentsWithStatus) {
                if (this.props.listIdCheckedShipmentsWithStatus[i]
                    !== shipmentStatus.READY_TO_TRANSMIT
                    && this.props.listIdCheckedShipmentsWithStatus[i]
                    !== shipmentStatus.PENDING_TRANSMIT) {
                    checkResult = false
                }
            }
            if (!checkResult) {
                alertError(lang.only_ready_to_transmit_can_transmetted)
            } else {
                this.showConfirmTransmit(this.props.listIdCheckedShipments, this.props.listIdCheckedShipmentsWithStatus)
            }
        }

    }

    toPrintCheck = (printOption = undefined) => {
        if (detectAdBlocker()) return;

        if (!this.CheckIsSelect()) {
            alertError("Please select package to print.!")
        } else if (this.props.listIdCheckedShipments.length > MaxPrintRecord) {
            alertError("Maximum records can print is " + MaxPrintRecord)
        }
        else {
            let countReadyToPrint = 0
            let checkResult = true
            for (let i in this.props.listIdCheckedShipmentsWithStatus) {
                if (!StatusCanPrint.includes(this.props.listIdCheckedShipmentsWithStatus[i])) {
                    checkResult = false
                }
                if (this.props.listIdCheckedShipmentsWithStatus[i] === shipmentStatus.READY_TO_PRINT) {
                    countReadyToPrint = countReadyToPrint + 1
                }
            }
            if (!checkResult) {
                alertError(lang.shipment_print_error)
            } else {
                if (countReadyToPrint > 0) {
                    this.showConfirmAddTrackingNo(this.props.listIdCheckedShipments, countReadyToPrint, printOption)
                } else {
                    this.confirmPrint(this.props.listIdCheckedShipments.length, printOption)
                }
            }
        }
    }

    CheckIsSelect() {
        if (this.props.listIdCheckedShipments.length === 0) {
            return false;
        }
        return true;
    }

    CheckToAddPackageInfo() {
        if (this.props.listIdCheckedShipments.length > 0) {
            this.props.addPackageInfo(this.props.listIdCheckedShipmentsWithStatus)
            this.props.getPackageInfoById(this.props.listIdCheckedShipments)
        }
        else {
            this.msgCheckOrder()
        }
    }

    msgCheckOrder() {
        alertError(lang.select_package_add_infor)
    }

    msgCheckOrderToDelete() {
        alertError(lang.select_package_delete)
    }

    msgCheckShipmentToClearTransmissionError() {
        alertError(lang.select_package_clear_transmission_error);
    }

    msgCreateNewAs() {
        alertError(lang.select_only_on_package)
    }

    CheckSelectedToCreateAsNew = () => {
        if (this.props.listIdCheckedShipments.length !== 1) {
            this.msgCreateNewAs()
            return false
        }
        let checkResult = true

        for (let i in this.props.listIdCheckedShipmentsWithStatus) {
            if (!StatusCanCreateAsNewOrder.includes(this.props.listIdCheckedShipmentsWithStatus[i])) {
                checkResult = false
            }
        }
        if (!checkResult) {
            alertError(lang.awaiting_package_infor_ready_transmit)
        } else {
            return true
        }
    }

    CheckSelectShipmentClearFeed = () => {
        if (this.props.listIdCheckedShipments.length !== 1) {
            this.msgCreateNewAs()
            return false
        }
        let checkResult = true

        for (let i in this.props.listIdCheckedShipmentsWithStatus) {
            if (!StatusCanCreateAsNewOrder.includes(this.props.listIdCheckedShipmentsWithStatus[i])) {
                checkResult = false
            }
        }
        if (!checkResult) {
            alertError(lang.confirm_clear_fail_transmit_shipment)
        } else {
            return true
        }
    }

    renderTitle = () => {
        let listTitle = []
        title.map((item, key) => {
            if (item.key !== 'PackageInfo') {
                listTitle.push(
                    <th key={key} width={item.width}>
                        <div className="warp-header">
                            <div className="title-header" onClick={() => {
                                this.props.onSort({
                                    column: item.key,
                                    params: { ...this.props.getShipmentParams, IsDesc: item.key === this.props.getShipmentParams.OrderBy ? !this.props.getShipmentParams.IsDesc : true }
                                })
                            }}>{item.title}</div>
                            <div className="sort-icon" onClick={() => {
                                this.props.onSort({
                                    column: item.key,
                                    params: { ...this.props.getShipmentParams, IsDesc: item.key === this.props.getShipmentParams.OrderBy ? !this.props.getShipmentParams.IsDesc : true }
                                })
                            }}>
                                <i className="fa fa-chevron-up" aria-hidden="true"
                                    style={{
                                        fontSize: '10px',
                                        color: this.props.orderBy == item.key && !this.props.isDesc ? '#00b0f0' : '#595959',
                                        display: item.key === 'ChannelID' ? 'none' : ''
                                    }}
                                />
                                <i className="fa fa-chevron-down" aria-hidden="true"
                                    style={{
                                        fontSize: '10px',
                                        color: this.props.orderBy == item.key && this.props.isDesc ? '#00b0f0' : '#595959',
                                        display: item.key === 'ChannelID' ? 'none' : ''
                                    }}
                                />
                            </div>
                        </div>
                    </th>
                )
            } else {
                listTitle.push(
                    <th style={{ cursor: 'default' }} key={key} width={item.width}>
                        <div style={{ cursor: 'default' }}
                            className="warp-header"
                        >
                            <div className="title-header">{item.title}</div>
                        </div>
                    </th>
                )
            }
        })
        return listTitle
    }
    renderFilterCount = () => {
        let textArray = []
        {
            let channelFilter = getFirstValueObj(this.props.input_filter.channel, this.props.shipmentReducer.listChannel);
            if (channelFilter) {
                textArray.push(
                    'Channel: ' + channelFilter
                )
            }
            if (this.props.input_filter.channel_order_no) {
                textArray.push(
                    'Channel Order: ' + this.props.input_filter.channel_order_no
                )
            }
            this.props.input_filter.type_list.sort(function (a, b) { return a - b }).map((a) => (
                textArray.push(
                    TypeStatus[a] + ' [' + (this.props.filter_count_type[a] || 0) + ']'
                )
            ))
            this.props.input_filter.status_list.sort(function (a, b) { return a - b }).map((a) => (
                textArray.push(
                    Status[a] + ' [' + (this.props.filter_count_status[a] || 0) + ']'
                )
            ))
            if (this.props.input_filter.tracking_number_from) {
                textArray.push(
                    'Tracking Number From: ' + this.props.input_filter.tracking_number_from
                )
            }
            if (this.props.input_filter.tracking_number_to) {
                textArray.push(
                    'Tracking Number To: ' + this.props.input_filter.tracking_number_to
                )
            }
            if (this.props.input_filter.order_date_from) {
                textArray.push(
                    'Order Date From: ' + this.props.input_filter.order_date_from
                )
            }
            if (this.props.input_filter.order_date_to) {
                textArray.push(
                    'Order Date To: ' + this.props.input_filter.order_date_to
                )
            }
            if (this.props.input_filter.shipping_date_from) {
                textArray.push(
                    'Ship Date From: ' + this.props.input_filter.shipping_date_from
                )
            }
            if (this.props.input_filter.shipping_date_to) {
                textArray.push(
                    'Ship Date To: ' + this.props.input_filter.shipping_date_to
                )
            }
        }
        return textArray.join(', ')
    }

    CheckingAddPackageInforOnSelected = () => {
        let checkResult = true;
        if (this.props.fulfillment_option === FulfillOptionConst.YAMATO.CODE) {
            return false;
        }
        if (this.props.listIdCheckedShipments.length === 0) {
            return false
        }
        for (let i in this.props.listIdCheckedShipmentsWithStatus) {
            if (this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.READY_TO_PRINT &&
                this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.READY_TO_TRANSMIT &&
                this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.PENDING_TRANSMIT &&
                this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.AWAITING_PACKAGE_INFO) {
                checkResult = false
            }
        }
        return checkResult;
    }

    CheckingReadyPrintOnSelected = () => {
        let checkResult = true;
        if (this.props.listIdCheckedShipments.length === 0) {
            return false
        }
        if (this.props.fulfillment_option === FulfillOptionConst.YAMATO.CODE) {
            for (let i in this.props.listIdCheckedShipmentsWithStatus) {
                if (this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.TRANSMITED &&
                    this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.TRANSMITED_KTE &&
                    this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.IMPORTED_KTE) {
                    checkResult = false
                }
            }
        } else {
            for (let i in this.props.listIdCheckedShipmentsWithStatus) {
                if (this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.READY_TO_PRINT &&
                    this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.READY_TO_TRANSMIT &&
                    this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.TRANSMITED &&
                    this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.TRANSMITED_KTE &&
                    this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.IMPORTED_KTE &&
                    this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.SHIPPED &&
                    this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.PENDING_TRANSMIT
                ) {
                    checkResult = false
                }
            }
        }

        return checkResult;
    }

    CheckingReadyTransmitOnSelected = () => {
        let checkResult = true;
        if (this.props.listIdCheckedShipments.length === 0) {
            return false
        }
        for (let i in this.props.listIdCheckedShipmentsWithStatus) {
            if (this.props.fulfillment_option === FulfillOptionConst.YAMATO.CODE) {
                if (this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.FULFILLMENT_IN_PROCESS
                    && this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.FULFILLMENT_COMPLETED
                    && this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.PENDING_TRANSMIT
                ) {
                    checkResult = false
                }
            } else {
                if (this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.READY_TO_TRANSMIT &&
                    this.props.listIdCheckedShipmentsWithStatus[i] !== shipmentStatus.PENDING_TRANSMIT
                ) {
                    checkResult = false;
                    break;
                }
            }

        }
        return checkResult;
    }

    CheckAllowCreateAsNewOrder = () => {
        if (this.props.listIdCheckedShipments.length === 0 || this.props.listIdCheckedShipments.length > 1) {
            return false
        }
        for (let i in this.props.listIdCheckedShipmentsWithStatus) {
            if (this.props.listIdCheckedShipmentsWithStatus[i] === shipmentStatus.AWAITING_PACKAGE_INFO ||
                this.props.listIdCheckedShipmentsWithStatus[i] === shipmentStatus.READY_TO_TRANSMIT ||
                this.props.listIdCheckedShipmentsWithStatus[i] === shipmentStatus.PENDING_TRANSMIT ||
                this.props.listIdCheckedShipmentsWithStatus[i] === shipmentStatus.READY_TO_PRINT ||
                this.props.listIdCheckedShipmentsWithStatus[i] === shipmentStatus.FULFILLMENT_IN_PROCESS ||
                this.props.listIdCheckedShipmentsWithStatus[i] === shipmentStatus.SHIPPING_IN_PROCESS ||
                this.props.listIdCheckedShipmentsWithStatus[i] === shipmentStatus.FULFILLMENT_COMPLETED
            ) {
                return true;
            }
        }
        return false;
    }

    CheckAllowDeleteShipment = () => {
        if (this.props.fulfillment_option === FulfillOptionConst.YAMATO.CODE) {
            return false;
        }
        if (this.props.listIdCheckedShipments.length === 0) {
            return false
        }
        else {
            for (let i in this.props.listIdCheckedShipmentsWithStatus) {
                if (StatusCanNotDelete.includes(this.props.listIdCheckedShipmentsWithStatus[i])) {
                    return false;
                }
            }
            return true;
        }
    }

    CheckAllowClearShipmentTransmissionError = () => {
        if (this.props.listIdCheckedShipments.length === 0) {
            return false
        }
        else {
            let checkedShipment = this.props.shipments.filter(sh => this.props.listIdCheckedShipments.includes(sh.PackageID));

            console.log('CheckAllowClearShipmentTransmissionError: ', checkedShipment);

            if (checkedShipment.length === 0) {
                return false;
            }

            for (let i = 0; i < checkedShipment.length; i++) {
                let sh = checkedShipment[i];

                if (!sh.FeedTransmitStatus) {
                    return false;
                }

                if (!FeedStatusCanClear.includes(sh.FeedTransmitStatus.FeedStatus)) {
                    return false;
                }

                if (!ChannelIdCanClearTransmissionError.includes(sh.ChannelID)) {
                    return false;
                }
            }

            return true;
        }
    }

    activeKey = () => {
        if (this.props.status_list.length === 1 && this.props.status_list[0] !== StatusFilterShipment.SHIPPED) {
            return this.props.status_list[0].toString()
        } else if (JSON.stringify(this.props.status_list) === JSON.stringify([StatusFilterShipment.SHIPPED, StatusFilterShipment.IN_TRANSIT])
            && this.props.input_filter.shipping_date_from === moment().format('MM/DD/YYYY')
            && this.props.input_filter.shipping_date_to === moment().format('MM/DD/YYYY')) {
            return "4"
        }
    }

    selectPrintOption = (e) => {
        this.toPrintCheck(Number(e.key))
    }

    onClickDataExport = () => {
        this.props.toggleDataExportVisibility({
            visibility: true
        });
    }

    isEnableExportShipment = () => {
        const { shipmentReducer: reducer } = this.props;
        if (!reducer.shipment_count || reducer.shipment_count === 0) return false;
        if (reducer.TransmittedCountByFilter !== reducer.shipment_count) {
            const status = Object.values(reducer.listIdCheckedShipmentsWithStatus);
            if (status.length === 0) return false;
            return status.every(element => ALLOWED_EXPORT_SHIPMENT_STATUS.includes(element));
        }
        return true;
    }

    printOptions = () => {
        const { printer: { PrintingOptionIN } } = this.props

        return (
            <Menu onClick={this.selectPrintOption}>
                <Menu.Item key={settingPrintOptions.ShippingLabelOnly}>
                    <span
                        className="printer-option-checked-mark"
                        style={{ visibility: settingPrintOptions.ShippingLabelOnly === PrintingOptionIN ? 'visible' : 'hidden' }}
                    >
                        &#10003;
                    </span>
                    <span>Shipping Label Only</span>
                </Menu.Item>
                <Menu.Item key={settingPrintOptions.ShippingLabelAndPacking}>
                    <span
                        className="printer-option-checked-mark"
                        style={{ visibility: settingPrintOptions.ShippingLabelAndPacking === PrintingOptionIN ? 'visible' : 'hidden' }}
                    >
                        &#10003;
                    </span>
                    <span>Shipping Label and Packing List</span>
                </Menu.Item>
                <Menu.Item key={settingPrintOptions.PackingListOnly}>
                    <span
                        className="printer-option-checked-mark"
                        style={{ visibility: settingPrintOptions.PackingListOnly === PrintingOptionIN ? 'visible' : 'hidden' }}
                    >
                        &#10003;
                    </span>
                    <span>Packing List Only (No Status Update)</span>
                </Menu.Item>
            </Menu>
        )
    }
    redirectSettingPrinter(e) {
        e.preventDefault();
        history.push('/setting/printer');
    }
    handleDisplayModalSettingPrinter = () => {
        this.setState({
            displayModalSettingPrinter: false
        })
    }

    shippedTodayTabClassname = () => {
        if ((this.props.ShippedTodayCount || 0) > 0) {
            return 'error-tab';
        } else {
            return '';
        }
    }

    shippedTodayTab = () => {
        const text = `Shipped Today (${this.props.ShippedTodayCount || 0})`;

        const content = (
            <div className='div-warning-popover'>
                <p>The data for some or all of these shipments was successfully transmitted to Yamato.</p>
                <p>BUT could not be transmitted to Amazon due to an error.</p>
                <p>For each error shipment with please click {<Icon type="edit" theme="outlined" />} to manually input shipment information on your Seller Central to mark it as "Shipped".</p>
                <p>You will need to enter the following fields, and for your convenience, the tracking number will be copied to your clipboard.</p>

                <p><b>"Ship Date"</b></p>
                <p><b>"Carrier" = "YAMATO TRANSPORT"</b></p>
                <p><b>"Tracking Number"</b></p>

                <p>Please click "YES" to clear the error from Y-Ship Cloud to remove the error status.</p>
            </div>
        )

        if ((this.props.ShippedTodayWithErrorCount || 0) > 0) {
            return (
                <div className="div-warning-tab">
                    <div className="div-warning-icon"><Popover className='tab-error-popover' trigger='hover' style={{ width: '50%' }} content={content} placement="left" color='red'><Icon type="exclamation" theme="outlined" /></Popover></div>
                    {text}
                </div>
            )
        } else {
            return text;
        }
    }

    render() {
        const InputGroup = Input.Group
        let styleIcon = { width: '100%', height: '100%', background: '#ffffff' }
        let styleIconDisable = { width: '100%', height: '100%', background: '#eeeeee' }
        let shipment_id = this.props.listIdCheckedShipments[0]
        let styleFilter = {
            width: '100%',
            height: '100%',
            background: this.props.add_filter ? '#474747' : '#ffffff',
            color: this.props.add_filter ? '#ffffff' : '#000000',
        }
        let checkReadyPrintOnSelected = this.CheckingReadyPrintOnSelected();
        let checkReadyTransmitOnSelected = this.CheckingReadyTransmitOnSelected();
        let checkAddPackageInfor = this.CheckingAddPackageInforOnSelected();
        let checkAllowCreateAsNew = this.CheckAllowCreateAsNewOrder();
        let checkAllowDeleteShipment = this.CheckAllowDeleteShipment();
        let checkAllowClearShipmentTransmissionError = this.CheckAllowClearShipmentTransmissionError();
        let listIdShipments = this.props.shipments.map(shipment => shipment.PackageID)
        let isChildArr = checkIsChildArr(this.props.listIdCheckedShipments, listIdShipments)
        let StringSelect
        let StringDisplay

        if (this.props.listIdCheckedShipments.length > 1) {
            StringSelect = 'shipments selected'
        } else { StringSelect = 'shipment selected' }
        if (this.props.shipment_count > 1) {
            StringDisplay = 'shipments displayed'
        } else { StringDisplay = 'shipment displayed' }

        const enableExportShipment = this.isEnableExportShipment() && handlePermission(permissions.ShipmentExportFeed);
        let FulfillmentFlg = parseInt(Storage.get('FulfillmentFlg'))

        return (


            <div id="box-utility-shipments">
                <Modal
                    className="popup-dialog"
                    visible={this.state.displayModalSettingPrinter}
                    footer={[
                        <Button key="submit" type="primary" onClick={() => this.handleDisplayModalSettingPrinter()}>
                            OK
                        </Button>,
                    ]}
                >
                    Your Printers are not selected. Please check your settings in <a onClick={(e) => this.redirectSettingPrinter(e)}>Printers</a>.
                </Modal>

                <Row className="top-shipment">
                    <Col span={4} className={`${this.state.title.class} title`} dangerouslySetInnerHTML={{ __html: this.state.title.content }} ></Col>
                    <Col span={20} className="quick-tab">

                        {
                            this.props.typeListShipment === FulfillOptionConst.YAMATO.TYPE_LINK ?
                                <Tabs
                                    activeKey={this.activeKey()}
                                    animated={{ inkBar: false, tabPane: false }}
                                    className="shipment-tab-panel"
                                    onChange={key => this.props.onTab({ tab: key, PageSize: this.props.getShipmentParams.PageSize, FulfillmentOption: FulfillOptionConst.YAMATO.CODE })}
                                >
                                    <TabPane tab={`Fulfillment In Process (${this.props.FulfillmentInProcessCount || 0})`} key={shipmentStatus.FULFILLMENT_IN_PROCESS}></TabPane>
                                    <TabPane tab={`Shipping In Process (${this.props.FulfillmentShippingInProcessCount || 0})`} key={shipmentStatus.SHIPPING_IN_PROCESS}></TabPane>
                                    <TabPane tab={`Fulfillment Completed (${this.props.FulfillmentCompletedCount || 0})`} key={shipmentStatus.FULFILLMENT_COMPLETED}></TabPane>
                                    <TabPane className={this.shippedTodayTabClassname()} tab={this.shippedTodayTab()} key={shipmentStatus.TRANSMITED} />
                                </Tabs>
                                :

                                <Tabs
                                    activeKey={this.activeKey()}
                                    animated={{ inkBar: false, tabPane: false }}
                                    className="shipment-tab-panel"
                                    onChange={key => this.props.onTab({ tab: key, PageSize: this.props.getShipmentParams.PageSize, FulfillmentOption: FulfillOptionConst.IN_HOUSE.CODE })}
                                >
                                    <TabPane tab={'Awaiting Package Information (' + (this.props.AwaitingPackageInformationCount || 0) + ')'} key={shipmentStatus.AWAITING_PACKAGE_INFO} />
                                    <TabPane tab={'Ready To Print (' + (this.props.ReadyToPrintCount || 0) + ')'} key={shipmentStatus.READY_TO_PRINT} />
                                    <TabPane tab={'Ready To Transmit (' + (this.props.ReadyToTransmitCount || 0) + ')'} key={shipmentStatus.READY_TO_TRANSMIT} />
                                    <TabPane className={this.shippedTodayTabClassname()} tab={this.shippedTodayTab()} key={shipmentStatus.TRANSMITED} />
                                </Tabs>
                        }
                    </Col>
                </Row>

                <Row className="body-shipment">
                    <Col span={10}>
                        <div className="box-utility">
                            <div className="filter-add">

                                {
                                    handlePermission(permissions.ShipmentUpdatePackageInfo) ?
                                        <div className="icon action big-icon add-package">
                                            <Tooltip placement="topLeft" title="Add Package Information">
                                                <Button style={checkAddPackageInfor ? styleIcon : styleIconDisable} size={'small'}
                                                    onClick={() =>
                                                        this.CheckToAddPackageInfo()
                                                    }
                                                    disabled={!checkAddPackageInfor}
                                                >
                                                    <img src={checkAddPackageInfor ? measureEna : measureDis} />
                                                </Button>
                                            </Tooltip>
                                        </div>
                                        : ""
                                }

                                {
                                    handlePermission(permissions.ShipmentGetPrintLabelInfo) ?
                                        <div className="icon action big-icon print">
                                            <InputGroup compact>
                                                <Tooltip placement="top" title="Print">
                                                    <Button
                                                        style={checkReadyPrintOnSelected ? styleIcon : styleIconDisable}
                                                        size={'small'}
                                                        className='button-print'
                                                        onClick={() => this.toPrintCheck()}
                                                        disabled={!checkReadyPrintOnSelected}
                                                    >
                                                        <img src={checkReadyPrintOnSelected ? printEna : printDis} />
                                                    </Button>
                                                </Tooltip>
                                                <Dropdown
                                                    overlay={this.printOptions}
                                                    trigger={['click']}
                                                    disabled={!checkReadyPrintOnSelected}
                                                >
                                                    <Button
                                                        style={checkReadyPrintOnSelected ? { background: '#fff' } : { background: '#eee' }}
                                                        className='print-dropdown'
                                                    >
                                                        <Icon className="print-dropdown-icon" type="down" />
                                                    </Button>
                                                </Dropdown>
                                            </InputGroup>
                                        </div>
                                        : ""
                                }

                                {
                                    handlePermission(permissions.ShipmentUpdatePackageStatus) ?
                                        <div className="icon action transmit big-icon transmit">
                                            <Tooltip placement="top" title="Transmit">
                                                <Button style={checkReadyTransmitOnSelected ? styleIcon : styleIconDisable} size={'small'}
                                                    onClick={() =>
                                                        this.toTransmitedCheck()
                                                    }
                                                    disabled={!checkReadyTransmitOnSelected}
                                                >
                                                    <img src={checkReadyTransmitOnSelected ? toTransmitEna : toTransmitDis} />
                                                </Button>
                                            </Tooltip>
                                        </div>
                                        : ""

                                }

                                {
                                    handlePermission(permissions.ShipmentExportFeed) ?
                                        <div className="icon action">
                                            <Tooltip placement="topLeft" title="Export Transmitted Shipments">
                                                <Button
                                                    style={enableExportShipment
                                                        ? { ...styleIcon, padding: '0' }
                                                        : { ...styleIconDisable, padding: '0' }}
                                                    size='small'
                                                    onClick={this.onClickDataExport}
                                                    disabled={!enableExportShipment}
                                                >
                                                    <img src={exportDataImg} style={{
                                                        width: '70%',
                                                        marginBottom: '3px',
                                                        opacity: enableExportShipment ? 1 : 0.3
                                                    }}
                                                    />
                                                </Button>
                                            </Tooltip>
                                        </div>
                                        : ""
                                }

                                {
                                    handlePermission(permissions.OrderCreateNewOrder) ?
                                        <div className="icon action">
                                            <Tooltip placement="top" title="Create As New Order">
                                                <Button style={checkAllowCreateAsNew ? styleIcon : styleIconDisable} size={'small'}
                                                    onClick={
                                                        () => !this.CheckSelectedToCreateAsNew() ? null : history.push('/add-order-from-shipment?shipment_id=' + shipment_id,
                                                            {
                                                                from: history.location.pathname,
                                                                status_list: this.props.status_list
                                                            })
                                                    }
                                                    disabled={!checkAllowCreateAsNew}
                                                >
                                                    <img src={checkAllowCreateAsNew ? copyEna : copyDis} style={{ width: '110%' }} />
                                                </Button>
                                            </Tooltip>
                                        </div>
                                        : ""
                                }

                                {
                                    handlePermission(permissions.ShipmentDeleteShipment) ?
                                        <div className="icon action">
                                            <Tooltip placement="top" title="Delete">
                                                <Button style={checkAllowDeleteShipment ? styleIcon : styleIconDisable} size={'small'}
                                                    onClick={
                                                        () => this.props.listIdCheckedShipments.length > 0 ? this.toCheckDelete() : this.msgCheckOrderToDelete()
                                                    }
                                                    disabled={!checkAllowDeleteShipment}
                                                >
                                                    <img src={checkAllowDeleteShipment ? deleteEna : deleteDis} style={{ width: '80%' }} />
                                                </Button>
                                            </Tooltip>
                                        </div>
                                        : ""
                                }

                                {
                                    handlePermission(permissions.ShipmentClearTransmissionErrorStatus) ?
                                        <div className="icon action">
                                            <Tooltip placement="top" title="Clear">
                                                <Button style={checkAllowClearShipmentTransmissionError ? styleIcon : styleIconDisable} size={'small'}
                                                    onClick={
                                                        () => this.props.listIdCheckedShipments.length > 0 ? this.toCheckClearTransmissionError() : this.msgCheckShipmentToClearTransmissionError()
                                                    }
                                                    disabled={!checkAllowClearShipmentTransmissionError}
                                                >
                                                    <img src={checkAllowClearShipmentTransmissionError ? clearEnable : clearDisable} style={{ width: '80%' }} />
                                                </Button>
                                            </Tooltip>
                                        </div>
                                        : ""
                                }

                                <div className={this.props.add_filter ? "icon" : "icon action"}>
                                    <Tooltip placement="top" title="Add Filter">
                                        <Button
                                            className={"no-padding"}
                                            style={styleFilter}
                                            size={'small'}
                                            onClick={() => this.props.addFilterShipment()}
                                        >
                                            <img src={this.props.add_filter ? filterEnable : filterDisble} style={{ width: '85%' }} />
                                        </Button>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col className="result" span={5} style={{ textAlign: "center" }}>
                        <div>
                            <span>{this.props.shipment_count || 0} {StringDisplay} - {this.props.listIdCheckedShipments.length || 0} {StringSelect}</span>
                        </div>
                    </Col>
                    <Col span={9}>
                        <span style={{ float: "right", marginTop: '15px' }}> Per Page</span>
                        <Select style={{ width: '100px', float: "right", margin: '9px 10px' }} value={this.props.offset}
                            onChange={e => {
                                this.props.onChangeOffset(e)
                                this.props.onSubmit({ ...this.props.getShipmentParams, PageSize: e, Page: 1, isChangeOffset: true })
                                this.props.update({ orderBy: this.props.getShipmentParams.OrderBy })
                            }}>
                            <Option value={10}>10</Option>
                            <Option value={50}>50</Option>
                            <Option value={100}>100</Option>
                            <Option value={500}>500</Option>
                        </Select>
                        <div className="pagination-center">
                            <div className="pagination" >
                                <a className="next-or-back"
                                    style={{ display: this.props.shipments.length != 0 ? 'block' : 'none' }}
                                    disabled={this.props.current_page == 1 ? true : false}
                                    onClick={() => {
                                        window.scrollTo(0, 0)
                                        return this.props.nextOrBack({
                                            type: 'back-head',
                                            current_page: this.props.current_page,
                                            params: this.props.getShipmentParams,
                                            pages: this.props.pages,
                                        })
                                    }
                                    }>
                                    <Icon
                                        type="step-backward"
                                        theme="outlined"
                                    />
                                </a>
                                <a className="next-or-back"
                                    style={{ display: this.props.shipments.length != 0 ? 'block' : 'none' }}
                                    disabled={this.props.current_page == 1 ? true : false}
                                    onClick={() => {
                                        window.scrollTo(0, 0)
                                        return this.props.nextOrBack({
                                            type: 'back',
                                            current_page: this.props.current_page,
                                            params: this.props.getShipmentParams,
                                            pages: this.props.pages,
                                        })
                                    }
                                    }>
                                    <Icon
                                        type="caret-left"
                                        theme="outlined"
                                    />
                                </a>
                                {this.Pagination(this.props.current_page, this.props.pages)}
                                <a className="next-or-back"
                                    style={{ display: this.props.shipments.length != 0 ? 'block' : 'none' }}
                                    disabled={this.props.current_page == this.props.pages ? true : false}
                                    onClick={() => {
                                        window.scrollTo(0, 0)
                                        return this.props.nextOrBack({
                                            type: 'next',
                                            current_page: this.props.current_page,
                                            params: this.props.getShipmentParams,
                                            pages: this.props.pages,
                                        })
                                    }
                                    }>
                                    <Icon
                                        type="caret-right"
                                        theme="outlined"
                                    />
                                </a>
                                <a className="next-or-back"
                                    style={{ display: this.props.shipments.length != 0 ? 'block' : 'none' }}
                                    disabled={this.props.current_page == this.props.pages ? true : false}
                                    onClick={() => {
                                        window.scrollTo(0, 0)
                                        return this.props.nextOrBack({
                                            type: 'next-last',
                                            current_page: this.props.current_page,
                                            params: this.props.getShipmentParams,
                                            pages: this.props.pages,
                                        })
                                    }
                                    }>
                                    <Icon
                                        type="step-forward"
                                        theme="outlined"
                                    />
                                </a>
                            </div>
                        </div>
                    </Col>
                    <AddFilterShipment typeListShipment={this.props.typeListShipment} />
                </Row>
                <Row className="quickfilter">
                    Filters:&nbsp;
                    {this.renderFilterCount().toString()}
                </Row>
                <Row className="quick-count-shipment">
                    <table className="table-orders">
                        <thead>
                            <tr>
                                <th width="2%">
                                    <Checkbox
                                        onChange={() => this.props.onCheckAll()}
                                        disabled={this.props.shipment_count === 0 ? true : false}
                                        checked={isChildArr}
                                    />
                                </th>
                                {this.renderTitle()}
                            </tr>
                        </thead>
                    </table>
                </Row>
            </div >
        )
    }
}

const mapStateToProps = state => {
    let startToday = moment().format('MM/DD/YYYY') + ' 00:00:00'
    let endToday = moment().format('MM/DD/YYYY') + ' 23:59:59'
    return {
        shipments: state.shipmentReducer.shipments,
        add_filter: state.shipmentReducer.add_filter,
        clear_feed_error: state.shipmentReducer.clear_feed_error,
        checkedShipments: state.shipmentReducer.checkedShipments,
        offset: state.shipmentReducer.offset,
        current_page: state.shipmentReducer.current_page,
        pages: state.shipmentReducer.pages,
        getShipmentParams: {
            Status: state.shipmentReducer.input_filter.status_list,
            Type: state.shipmentReducer.input_filter.type_list,
            FulfillmentOption: state.shipmentReducer.fulfillment_option,
            OrderDateFrom: convertDateToUTC(new Date(state.shipmentReducer.input_filter.order_date_from + ' 00:00:00')),
            OrderDateTo: convertDateToUTC(new Date(state.shipmentReducer.input_filter.order_date_to + ' 23:59:59')),
            ShippingDateFrom: convertDateToUTC(new Date(state.shipmentReducer.input_filter.shipping_date_from + ' 00:00:00')),
            ShippingDateTo: convertDateToUTC(new Date(state.shipmentReducer.input_filter.shipping_date_to + ' 23:59:59')),
            StartToday: convertDateToUTC(new Date(startToday)),
            EndToday: convertDateToUTC(new Date(endToday)),
            TrackingNumberFrom: state.shipmentReducer.input_filter.tracking_number_from,
            TrackingNumberTo: state.shipmentReducer.input_filter.tracking_number_to,
            OrderBy: state.shipmentReducer.orderBy,
            IsDesc: state.shipmentReducer.isDesc,
            PageSize: state.shipmentReducer.offset,
            Page: state.shipmentReducer.current_page,
            ChannelOrderID: state.shipmentReducer.input_filter.channel_order_no,
            ChannelID: state.shipmentReducer.input_filter.channel,
            SelectedIds: state.shipmentReducer.listIdCheckedShipments,
        },
        filter_count_status: state.shipmentReducer.filter_count_status,
        filter_count_type: state.shipmentReducer.filter_count_type,
        input_filter: state.shipmentReducer.input_filter,
        shipment_count: state.shipmentReducer.shipment_count,
        isCheckedAll: state.shipmentReducer.isCheckedAll,
        listIdCheckedShipments: state.shipmentReducer.listIdCheckedShipments,
        listIdCheckedShipmentsWithStatus: state.shipmentReducer.listIdCheckedShipmentsWithStatus,
        listIdCheckedShipmentsWithChannelId: state.shipmentReducer.listIdCheckedShipmentsWithChannelId,
        status_list: state.shipmentReducer.input_filter.status_list,
        AwaitingPackageInformationCount: state.shipmentReducer.AwaitingPackageInformationCount,
        ReadyToPrintCount: state.shipmentReducer.ReadyToPrintCount,
        ReadyToTransmitCount: state.shipmentReducer.ReadyToTransmitCount,
        ShippedTodayCount: state.shipmentReducer.ShippedTodayCount,
        ShippedTodayWithErrorCount: state.shipmentReducer.ShippedTodayWithErrorCount,
        TransmitFailCount: state.shipmentReducer.TransmitFailCount,
        getting_label_info: state.shipmentReducer.getting_label_info,
        label_data: state.shipmentReducer.label_data,
        loading: state.shipmentReducer.loading,
        popup_error: state.shipmentReducer.popup_error,
        delete_shipment_modal: state.shipmentReducer.delete_shipment_modal,
        orderBy: state.shipmentReducer.orderBy,
        isDesc: state.shipmentReducer.isDesc,
        printer: state.headerReducer.Printer,
        visibleEditOrder: state.editOrder.visibleEditOrder,
        shipmentReducer: state.shipmentReducer,
        FulfillmentInProcessCount: state.shipmentReducer.FulfillmentInProcessCount,
        FulfillmentCompletedCount: state.shipmentReducer.FulfillmentCompletedCount,
        FulfillmentShippingInProcessCount: state.shipmentReducer.FulfillmentShippingInProcessCount,
        fulfillment_option: state.shipmentReducer.fulfillment_option,
        Summary: state.headerReducer.Summary
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onCheckAll: () => {
            dispatch(onCheckAll())
        },
        onSort: payload => {
            dispatch(onSort(payload))
        },
        addFilterShipment: () => {
            dispatch(addFilterShipment())
        },
        getShipmentsByPage: payload => {
            dispatch(getShipmentsByPage(payload))
        },
        onChangeOffset: payload => {
            dispatch(onChangeOffset(payload))
        },
        nextOrBack: payload => {
            dispatch(nextOrBack(payload))
        },
        addPackageInfo: payload => {
            dispatch(addPackageInfo(payload))
        },
        toTransmited: payload => {
            dispatch(toTransmited(payload))
        },
        deleteShipment: payload => {
            dispatch(deleteShipment(payload))
        },
        clearShipmentFeed: payload => {
            dispatch(clearShipmentFailFeed(payload))
        },
        onSubmit: payload => {
            dispatch(onSubmit(payload))
        },
        onTab: payload => {
            dispatch(onTab(payload))
        },
        getLabelInfo: payload => {
            dispatch(getLabelInfo(payload))
        },
        getPackageInfoById: (payload) => {
            dispatch(getPackageInfoById(payload))
        },
        getPackageInfoByShipmentId: (payload) => {
            dispatch(getPackageInfoByShipmentId(payload))
        },
        changeEditOrder: (payload) => {
            dispatch(changeEditOrder(payload))
        },
        update: payload => {
            dispatch(update(payload))
        },
        onLoadPrinter: payload => {
            dispatch(onLoadPrinter(payload))
        },
        toggleDataExportVisibility: payload => {
            dispatch(toggleDataExportVisibility(payload))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BoxUtility)



// WEBPACK FOOTER //
// ./src/containers/shipments/components/box-utility/index.js